import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorSlug}/payouts.csv']['GET'];

type GetPayoutsResponse = ThisApi['response'];

const getPayoutCsv = async ({ creatorSlug, ...restProps }: ThisApi['params'] & ThisApi['query']): Promise<GetPayoutsResponse> => {
  const response = await noodleApiClient.get(`/creators/${creatorSlug}/payouts.csv`, { params: { ...restProps }});
  return response.data;
};

export default getPayoutCsv;
